<template>
  <div>
    <PageHeaderBanner>
      <template #title>SDFile項目確認</template>
    </PageHeaderBanner>
    <MessageChip :display="isMessageChip" level="E" :message="errMessage" />
    <q-form
      greedy
      @submit="displayRegisterDialog"
      @reset="clearData"
      @validation-error="resetError"
    >
      <div class="cmd00711-input-form">
        <div :class="'q-mb-md sdfile-area ' + (isSdfileNameLength ? 'filename-long' : '')">
          <div class="column sdfile-name">
            <label>SDFile名</label>
            <span class="q-ml-sm q-mt-xs">
              {{ fileName }}
            </span>
          </div>
          <div class="column sdfile-size">
            <label>ファイルサイズ</label>
            <span class="q-ml-sm q-mt-xs">
              {{ fileSize }}
            </span>
          </div>
        </div>
        <div class="cmd00711-input-select row q-gutter-x-sm items-end q-mb-lg">
          <div class="col">
            <label class="requier">サプライヤ名</label>
            <SupplierSelects
              :supplier="supplier"
              :is-validate="true"
              @select-supplier="setSupplierValue"
            />
          </div>
          <div class="col">
            <label class="requier">カテゴリー</label>
            <CategorySelects
              :category="category"
              :is-validate="true"
              @select-category="setCategoryValue"
            />
          </div>
          <div class="col-1.5 cmd00711-template-button">
            <q-btn
              color="primary"
              style="width: 200px; height: 40px"
              :class="supplier && category ? '' : 'cmd00711-disabled-btn'"
              label="テンプレートを読み込む"
              :disable="supplier && category ? false : true"
              @click="readTemplete"
            />
            <q-tooltip
              v-if="supplier && category ? false : true"
              anchor="top middle"
              self="bottom middle"
              :offset="[15, 15]"
            >
              <strong>サプライヤ名とカテゴリーを選択してください</strong>
            </q-tooltip>
          </div>
        </div>
        <div class="cmd00711-item-table q-mb-md">
          <label class="text-weight-bold" style="font-size: 1.1rem">項目名設定</label>
          <div :class="'chem-table-area ' + (rows.length === 0 ? 'table-nodata' : '')">
            <q-table
              :rows="rows"
              :columns="colums"
              row-key="number"
              flat
              separator="cell"
              hide-pagination
              :rows-per-page-options="[rows.length]"
              class="q-mb-xl"
            >
              <template #body="cell">
                <q-tr>
                  <q-td key="number" class="text-right" style="width: 1.5rem">
                    {{ cell.row.number }}
                  </q-td>
                  <q-td key="file_item_name">
                    {{ cell.row.file_item_name }}
                  </q-td>
                  <q-td style="min-width: 280px">
                    <SystemItemSelects
                      :id="cell.row.system_item_code"
                      :error="cell.row.error"
                      @select-item="cell.row.system_item_code = $event"
                    />
                  </q-td>
                </q-tr>
              </template>
            </q-table>
            <div class="row">
              <div class="col" style="margin-top: 2px">
                <q-checkbox v-model="addTempleteFlag">テンプレートとして登録する</q-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class="cmd00711-other-setting-area">
          <label class="text-weight-bold" style="font-size: 1.1rem">その他設定</label>
          <div class="row q-mt-sm">
            <div class="col">
              <label>過去SDFile名</label>
              <PastSdfileSelects
                :options="pastSdfileOptions"
                :past-sdf="pastSdfile"
                @select-past-sdf="pastSdfile = $event"
              />
            </div>
          </div>
          <div class="row q-mt-sm">
            <div class="col">
              <label>備考</label>
              <q-input
                v-model="memo"
                outlined
                dense
                type="textarea"
                counter
                rows="2"
                bg-color="white"
                maxlength="200"
                class="q-pb-none"
              />
            </div>
          </div>
        </div>
        <FormFooterBanner style="position: inherit">
          <template #button-area>
            <div class="row">
              <q-btn
                color="grey-7"
                outline
                label="戻る"
                style="min-width: 120px; background: var(--q-white) !important"
                @click="backPage"
              />
              <div class="col q-gutter-x-xs flex justify-end">
                <q-btn type="submit" color="primary" style="width: 150px" label="登録" />
                <q-btn
                  type="reset"
                  outline
                  style="
                    width: 150px;
                    background: var(--q-white) !important;
                    color: var(--q-delete);
                  "
                  icon="mdi-eraser"
                  label="クリア"
                />
              </div>
            </div>
          </template>
        </FormFooterBanner>
      </div>
    </q-form>
    <!-- テンプレート読込ダイアログ -->
    <AlertDialog
      :display="isTemplateDialogFlg"
      :level="dialogLevel"
      :confirmation="isConfFlg"
      :title="dialogTitle"
      :text="dialogText"
      @complete="isTemplateDialogFlg = false"
      @close="isTemplateDialogFlg = false"
    />
    <!-- システム取込名0件エラーダイアログ -->
    <AlertDialog
      :display="isEmptySdfDialogFlg"
      :level="dialogLevel"
      :confirmation="isConfFlg"
      :title="dialogTitle"
      :text="dialogText"
      @complete="backPage"
      @close="backPage"
    />
    <!-- 登録ダイアログ -->
    <AlertDialog
      :display="isRegisterDialogFlg"
      :level="dialogLevel"
      :confirmation="isConfFlg"
      :title="dialogTitle"
      :text="dialogText"
      @complete="backPage"
      @confirm="registerSdf"
      @close="isRegisterDialogFlg = false"
    />
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { Loading } from 'quasar';
import axios from '../../common/axios-common';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import SystemImportItemCode from '../../common/code/SystemImportItemCode';
import CategorySelects from '../../components/selects/CategorySelects.vue';
import PastSdfileSelects from '../../components/selects/PastSdfileSelects.vue';
import SupplierSelects from '../../components/selects/SupplierSelects.vue';
import SystemItemSelects from '../../components/selects/SystemItemSelects.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import FormFooterBanner from '../../components/banner/FormFooterBanner.vue';
import MessageChip from '../../components/chip/MessageChip.vue';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';

interface Props {
  // SDFile名
  fileName: string;
}

// アップロードSDFile一覧
interface NameSettingColumn {
  number: number;
  file_item_name: string;
  system_item_name: string;
}

// プルダウン
interface Options {
  label: string;
  value: string;
}

// SDFile項目名
interface SdFileItemName {
  number: number;
  file_item_name: string;
  system_item_code: string;
  error: boolean;
}

const router = useRouter();
const props = defineProps<Props>();

// SDFファイル名
const fileName = ref('');
// SDファイル名の長さが45文字を超えているかどうか
const isSdfileNameLength = ref(false);
// SDFファイルサイズ
const fileSize = ref('');
// サプライヤ
const supplier = ref('');
// カテゴリー
const category = ref('');
// 過去SDFile
const pastSdfile = ref('');
// 過去SDFileプルダウン
const pastSdfileOptions = ref<Options[]>([]);
// 備考
const memo = ref('');
// 「テンプレートとして登録する」フラグ
const addTempleteFlag = ref(false);

// Dialogタイトル
const dialogTitle = ref('');
// Dialog表示レベル
const dialogLevel = ref('');
// Dialog本文
const dialogText = ref(['']);
// 確認Dialogフラグ
const isConfFlg = ref(false);
// テンプレートDialog表示フラグ
const isTemplateDialogFlg = ref(false);
// 取込項目名0件エラーDialog表示フラグ
const isEmptySdfDialogFlg = ref(false);
// 登録Dialog表示フラグ
const isRegisterDialogFlg = ref(false);

// エラーメッセージ
const errMessage = ref('');
// MessageChip表示フラグ
const isMessageChip = ref(false);

// 項目名設定カラム
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const colums: Array<any> = [
  {
    name: 'number',
    label: '番号',
    align: 'left',
    field: (row: NameSettingColumn) => row.number,
    classes: 'text-right',
  },
  {
    name: 'file_item_name',
    label: 'SDFile項目名',
    align: 'left',
    field: (row: NameSettingColumn) => row.file_item_name,
  },
  {
    name: 'system_item_name',
    label: 'システム取込項目名',
    align: 'left',
    field: (row: NameSettingColumn) => row.system_item_name,
    headerClasses: 'system-input',
  },
];

// テーブルデータ
const rows = ref<SdFileItemName[]>([]);

/**
 * エラーチップを初期化
 */
const resetError = async () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

/**
 * データクリア
 */
const clearData = () => {
  supplier.value = '';
  category.value = '';
  pastSdfile.value = '';
  memo.value = '';
  addTempleteFlag.value = false;
  errMessage.value = '';
  isMessageChip.value = false;
  // システム取込項目名プルダウン初期化
  rows.value.forEach((value, index) => {
    rows.value[index].system_item_code = '';
    rows.value[index].error = false;
  });
};

/**
 * SDFile登録画面に戻る
 */
const backPage = () => {
  router.push({ name: 'sdfileRegist' });
};

/**
 * 登録確認ダイアログ表示
 */
const displayRegisterDialog = () => {
  dialogTitle.value = '登録確認';
  dialogLevel.value = 'information';
  dialogText.value = ['入力された内容で登録します。', 'よろしいですか？'];
  isConfFlg.value = false;
  isRegisterDialogFlg.value = true;
};

/**
 * 登録完了ダイアログ
 */
const completeRegisterDialog = () => {
  dialogTitle.value = '登録完了';
  dialogLevel.value = 'information';
  dialogText.value = ['登録が完了しました。'];
  isConfFlg.value = true;
  isRegisterDialogFlg.value = true;
};

/**
 * 初期表示データ取得
 */
const getInitData = () => {
  // Loading Start
  Loading.show();
  const formData = new FormData();
  formData.append('file_name', props.fileName);
  // 項目名設定の番号
  let number = 1;

  axios
    .post('/cmd007111/init', formData)
    .then((res) => {
      const { common, sdfTempFile } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          fileName.value = sdfTempFile.file_name;
          // 文字数が60文字を超えていたら画面のファイルサイズをSDFile名の下に移動
          if (fileName.value.length >= 60) {
            isSdfileNameLength.value = true;
          }
          fileSize.value = sdfTempFile.file_size;
          // SDFile項目名が0件の場合
          if (sdfTempFile.sdFileNameList.length === 0) {
            // エラーダイアログ表示
            dialogTitle.value = 'ファイル読み込みエラー';
            dialogLevel.value = 'error';
            dialogText.value = [
              'SDFileの形式に誤りがあります。',
              '内容を確認して、再度SDFileをアップロードしてください。',
            ];
            isConfFlg.value = true;
            isEmptySdfDialogFlg.value = true;
          } else {
            // 項目名設定
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            sdfTempFile.sdFileNameList.forEach((value: any) => {
              Object.entries(value).forEach(([key]) => {
                rows.value.push({
                  number,
                  file_item_name: key,
                  system_item_code: '',
                  error: false,
                });
                number += 1;
              });
            });
          }
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            // ファイルが存在しない場合
            case DetailResultStatusCode.FILE_NOT_EXIST_ERROR:
              dialogTitle.value = 'ファイル読み込みエラー';
              dialogLevel.value = 'error';
              dialogText.value = [common.message];
              isConfFlg.value = true;
              isEmptySdfDialogFlg.value = true;
              break;

            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;
            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * テンプレート読み込み
 */
const readTemplete = () => {
  // Loading Start
  Loading.show();
  // システム取込項目名プルダウンのクリア
  rows.value.forEach((value, index) => {
    rows.value[index].system_item_code = '';
    rows.value[index].error = false;
  });
  const formData = new FormData();
  formData.append('supplier_code', supplier.value);
  formData.append('category_id', category.value);

  axios
    .post('/cmd007111/read-template', formData)
    .then((res) => {
      const { common, mapTemplate } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // テンプレート設定
          Object.entries(mapTemplate).forEach(([key, value]) => {
            rows.value.forEach((item, index) => {
              // SDFile項目名とインポートファイルマップテーブルの項目名が一致した場合
              if (item.file_item_name === value) {
                // システム取込項目名を設定
                rows.value[index].system_item_code = SystemImportItemCode[key];
              }
            });
          });
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            // テンプレートが未登録の場合
            case DetailResultStatusCode.TEMPLATE_NOT_EXIST_ERROR:
              // 「テンプレートを登録する」をチェック状態にする
              addTempleteFlag.value = true;
              // 警告ダイアログ表示
              dialogTitle.value = 'テンプレート未登録';
              dialogLevel.value = 'warning';
              dialogText.value = [common.message];
              isConfFlg.value = true;
              isTemplateDialogFlg.value = true;
              break;

            // システムエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * 過去SDFile名取得
 */
const getPastSdfFileName = () => {
  const formData = new FormData();
  formData.append('supplier_code', supplier.value);
  formData.append('category_id', category.value ? category.value : '');

  axios
    .post('/cmd007111/past-sdf-file', formData)
    .then((res) => {
      const { common, pastSdfList } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // プルダウン内容を設定
          pastSdfList.forEach((pastSdf: { sup_sdfile_name: string; catalog_id: string }) => {
            pastSdfileOptions.value.push({
              label: pastSdf.sup_sdfile_name,
              value: pastSdf.catalog_id,
            });
          });
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    });
};

/**
 * SDFile登録
 */
const registerSdf = () => {
  // Loading Start
  Loading.show();
  // データリセット
  errMessage.value = '';
  isMessageChip.value = false;
  isRegisterDialogFlg.value = false;
  rows.value.forEach((value, index) => {
    rows.value[index].error = false;
  });

  // 登録データ設定
  const formData = new FormData();
  formData.append('file_name', fileName.value);
  formData.append('supplier_code', supplier.value);
  formData.append('category_id', category.value ? category.value : '');
  rows.value.forEach((value) => {
    formData.append(`item_map[${value.file_item_name}]`, value.system_item_code);
  });
  formData.append('del_catalog_id', pastSdfile.value);
  formData.append('memo', memo.value);
  formData.append('add_templete_flag', addTempleteFlag.value ? '1' : '0');

  axios
    .post('/cmd007111/register-sdf-file', formData)
    .then((res) => {
      const { common, errCodeItems } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // 完了ダイアログ表示
          completeRegisterDialog();
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            // IDNUMBERが存在しない場合
            case DetailResultStatusCode.IDNUMBER_NOT_EXIST_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            // システム取込み項目名が重複している場合
            case DetailResultStatusCode.DUPLICATE_SYSTEM_NAME_ERROR:
              // 重複しているシステム取込み項目名プルダウンにエラーを設定
              rows.value.forEach((value, index) => {
                errCodeItems.forEach((code: string) => {
                  if (value.system_item_code === code) {
                    rows.value[index].error = true;
                  }
                });
              });
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            // システムエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
      // TOPにスクロール
      setTimeout(() => window.scrollTo({ top: 0 }), 400);
    });
};

/**
 * サプライヤプルダウンの選択値設定
 * @param {string} event プルダウン選択値
 */
const setSupplierValue = (event: string) => {
  // プルダウン選択値を設定
  supplier.value = event;
  // プルダウン初期化
  pastSdfileOptions.value = [];
  pastSdfile.value = '';
  // サプライヤ、カテゴリどちらも入力されている場合、過去SDFile名プルダウン取得
  if (!!supplier.value && !!category.value) {
    getPastSdfFileName();
  }
};

/**
 * カテゴリプルダウンの選択値設定
 * @param {string} event プルダウン選択値
 */
const setCategoryValue = (event: string) => {
  // プルダウン選択値を設定
  category.value = event;
  // プルダウン初期化
  pastSdfileOptions.value = [];
  pastSdfile.value = '';
  // サプライヤ、カテゴリどちらも入力されている場合、過去SDFile名プルダウン取得
  if (!!supplier.value && !!category.value) {
    getPastSdfFileName();
  }
};

/**
 * 初期表示処理
 */
// propsが存在しない場合
if (!props.fileName) {
  // 前画面に遷移
  backPage();
} else {
  // 初期表示データ取得
  getInitData();
}
</script>
<style scoped>
.cmd00711-input-form {
  width: 70%;
  margin: 0 auto;
  padding-top: 8px;
}

.sdfile-area {
  display: flex;
  flex-wrap: wrap;
}

.cmd00711-input-form .sdfile-name {
  width: 65%;
}

.cmd00711-input-form .sdfile-name span {
  word-break: break-all;
}

.filename-long .sdfile-name {
  width: 100%;
  margin: 0;
  margin-bottom: 12px;
}

.sdfile-size {
  width: 33%;
  margin-left: 2%;
}

.filename-long .sdfile-size {
  width: 100%;
  margin: 0;
}

.cmd00711-template-button {
  display: flex;
  align-items: flex-end;
  margin: 0 0 0 20px;
}
</style>
<style>
.cmd00711-item-table .q-table__container {
  margin: 6px auto 0 !important;
}

.cmd00711-item-table .system-input {
  width: 250px;
  min-width: 250px;
  max-width: 250px;
}

.cmd00711-template-button .cmd00711-disabled-btn {
  background-color: var(--q-opacityDisable) !important;
}

.cmd00711-other-setting-area .q-textarea .q-field__control {
  padding-right: 3px;
}
</style>
